import { useMediaQuery as q } from 'react-responsive';

export default function useMediaQuery(query: string) {
  return q({ query });
}
